import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-navy-card relative overflow-hidden" data-id="element-269">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-270"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-271">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-272">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gold/10 text-gold mb-5" data-id="element-273">
            <span className="text-2xl" data-id="element-274">🏆</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4" data-id="element-275">
            The most complete Spanish teaching system for middle and high school
            teachers worldwide
          </h2>
          <h3 className="text-xl font-bold text-gold-gradient mb-3" data-id="element-276">
            Spanish Teacher Ready™
          </h3>
          <p className="text-base md:text-lg text-gray-300 mb-10" data-id="element-277">
            120 Ready-to-Teach Spanish Lessons · 5 Strategic Bonuses ·
            Everything ready to use from today
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-278">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-3 bg-black p-6 rounded-2xl border border-navy-border" data-id="element-279">
            <div className="flex items-start gap-3" data-id="element-280">
              <X className="text-red-500 shrink-0 mt-1" size={18} data-id="element-281" />
              <p className="text-gray-400 text-sm" data-id="element-282">
                This is not a collection of random worksheets pulled from the
                internet.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-283">
              <X className="text-red-500 shrink-0 mt-1" size={18} data-id="element-284" />
              <p className="text-gray-400 text-sm" data-id="element-285">
                This is not a theory book you need to rewrite before it works in
                a real classroom.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-286">
              <X className="text-red-500 shrink-0 mt-1" size={18} data-id="element-287" />
              <p className="text-gray-400 text-sm" data-id="element-288">
                This is not content designed for a different context that you
                have to completely adapt.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gold/10 p-6 rounded-2xl border border-gold/30 relative overflow-hidden" data-id="element-289">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gold/20 blur-3xl rounded-full" data-id="element-290"></div>
            <div className="flex items-start gap-3 relative z-10" data-id="element-291">
              <Check className="text-gold shrink-0 mt-1" size={20} data-id="element-292" />
              <p className="text-white font-medium text-base leading-relaxed" data-id="element-293">
                This is a complete professional teaching system — so you walk
                into every single class fully prepared, confident and ready to
                deliver a lesson your students will actually learn from.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}